/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Epic, ofType, StateObservable } from 'redux-observable';
import * as L from 'lodash';
import { IAction } from '../../actions/IshAction';
import { mergeMap, Observable } from 'rxjs';
import { IshState } from '../../services/IshState';
import { REWRITE_CONTACT_NODE_TO_STATE, UPDATE_ENROLMENT_FIELDS } from '../containers/summary/actions/Actions';
import { toFormKey } from '../../components/form/FieldFactory';
import { Field, DataType } from '@api';

export const EpicUpdateEnrolmentFields: Epic<any, any> = (action$:  Observable<IAction>, store: StateObservable<IshState>): Observable<any> => {
  return action$.pipe(
    ofType(UPDATE_ENROLMENT_FIELDS),
    mergeMap((action: IAction): any => {
      const state = store.value;
      const result = [];

      // form name `[contactId]-[classId]` format. The same as enrolmentId in ContactNodes
      const { form, type } = action.payload;

      if (state.form[form] && state.form[form].values) {

        const values = state.form[form].values;
        const headings = state.checkout.summary.entities[type][form]?.fieldHeadings || [];

        headings.forEach(h => {
          h.fields.forEach((f: Field, i) => {
            const formKey = toFormKey(f.key, i);

            f.value = values[formKey] && values[formKey].key || values[formKey] || null;
            if (f.value == null && f.dataType === DataType.BOOLEAN) {
              f.value = 'false';
            }
          });
        });

        const newState = L.cloneDeep(state.checkout.summary);

        if (newState?.entities[type] && newState.entities[type][form]) {
          newState.entities[type][form].fieldHeadings = headings;
        }

        result.push({
          type: REWRITE_CONTACT_NODE_TO_STATE,
          payload: newState,
        });
      }

      return result;
    })
  );
};
